import CollectGraphicsStatus from "./collect-graphics-status";

const CollectGraphicsHelpers = {
    Status: CollectGraphicsStatus
};

export default CollectGraphicsHelpers;